const baseURLVer1 = '/api/v1/role';

export default {
  /**
   * @GET 역할 검색
   * - assignableOnly=true 이면 임직원 프로필에 부여되는 법인/사업부/팀 역할만 조회.
   */
  ROLE_SEARCH: `${baseURLVer1}/search`,
};
